import CreateCourse from "./CreateCourse";

export default CreateCourse;
